import { gsap, ScrollTrigger } from "./globals.js";
import { animateChars } from './animate-chars.js';

document.addEventListener("DOMContentLoaded", () => {
	ScrollTrigger.addEventListener("refreshInit", () => {
		document.querySelectorAll('.offices__row').forEach((row, i) => {
		    const cols = row.querySelectorAll('.offices__row__col');

		    // Animate columns inside each row
		    const tl = gsap.timeline({
		      scrollTrigger: {
		        trigger: row,
		        start: 'top 80%',
		        toggleActions: 'play none none none',
		      }
		    });

		    tl.to(cols, {
		      opacity: 1,
		      y: 0,
		      stagger: {
		        each: 0.15,
		        overlap: 0.1
		      },
		      duration: 2,
		      ease: 'power2.out',
		    });
		  });
	});
});
